import { createFileRoute } from '@tanstack/react-router'

import { TenantHealthPage } from '@/pages/tenants/detail/TenantHealthPage'

export const Route = createFileRoute('/_authenticated/tenants/$id/health')({
  component: TenantHealthPage,
})
